import { memo } from "react";
import { DownloadButton } from "../../resource/DownloadButton";
import React from "react";
import { LSResultItemLayout } from "./LSResultItem/LSResultItemLayout";
import { LSResultItemCheckbox } from "./LSResultItem/LSResultItemCheckbox";
import { LSResultItemBookjacket } from "./LSResultItem/LSResultItemBookjacket";
import { LSResultItemTitle } from "./LSResultItem/LSResultItemTitle";
import { LSResultItemAuthor } from "./LSResultItem/LSResultItemAuthor";
import { Box, Chip, Typography } from "@mui/material";
import { RateAndReview } from "@tlc/ls2pac/components/rate-and-review/RateAndReview";
import { DownloadableItemAvailability } from "./DownloadableItemAvailability";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { LSResultItemAddToListButton } from "./LSResultItem/LSResultItemAddToListButton";
import { LSResultItemReadingLevelDisplay } from "./LSResultItem/LSResultItemReadingLevelDisplay";
import { ResourceView } from "@tlc/ls2pac/dto/ResourceView";
import { ResourceSeriesLink } from "./ResourceSeriesLink";

export const LSDownloadableItem = memo(
  function SearchResult({ resource }: { resource: ResourceView }) {
    const { translate } = useLanguage();

    const actionsComponent = (
      <>
        <DownloadButton resource={resource} />
        <LSResultItemAddToListButton
          resource={resource}
        ></LSResultItemAddToListButton>
      </>
    );

    return (
      <LSResultItemLayout
        checkboxComponent={<LSResultItemCheckbox resource={resource} />}
        bookjacketComponent={<LSResultItemBookjacket resource={resource} />}
        titleComponent={<LSResultItemTitle resource={resource} />}
        actionsComponent={actionsComponent}
        authorComponent={
          <LSResultItemAuthor shortAuthor={resource.shortAuthor} />
        }
      >
        {/* Format label and rating */}
        <Box display="flex" alignItems="center" gap={2}>
          {resource.format && (
            <Box>
              <Chip variant="outlined" label={resource.format} />
            </Box>
          )}

          <RateAndReview material={resource}></RateAndReview>
        </Box>

        {/* Series */}
        {resource.mainSeries && (
          <Typography variant="subtitle2">
            {translate("series")}: <ResourceSeriesLink resource={resource} />
          </Typography>
        )}
        {/* TODO for Downloadable? */}
        <LSResultItemReadingLevelDisplay resource={resource} />
        <DownloadableItemAvailability resource={resource} />
      </LSResultItemLayout>
    );
  },
  (prevProps, nextProps) => prevProps.resource.id === nextProps.resource.id
);
